/* eslint-disable */
import React, { useEffect } from "react";
import GeneralForm from "@/features/clients/create/components/generalForm";
import AddressForm from "@/features/clients/create/components/addressForm";
import ContactForm from "@/features/clients/create/components/contactForm";
import { LoadingButton } from "@mui/lab";
import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { TAccordionForm } from "@/features/clients/create/types";
import { TStep } from "@/components/forms/Accordion/types";
import { AccordionWrapper } from "@/components/forms";
import { Icon } from '@iconify/react';
import alertCircleFill from '@iconify/icons-eva/alert-circle-fill';
import { PRIMARY } from "@/theme/palette";
import MenuItemModalFormAccordion from "@/components/modal/MenuItemModalFormAccordion";

const AccordionForm = (
    {
        onSubmit,
        initialValues,
        validateForm,
        required,
        selectDataCountry,
        selectDataRegime,
        submitting,
        isModal,
        icon,
        callback,
        setModalOpen,
        loading
    }: TAccordionForm
): any => {
    const [t] = useTranslation();

    const hasErrorStep = (
        submitFailed: boolean,
        touched: { [p: string]: boolean } | undefined,
        errors: any | undefined,
        index: number,
    ) => {
        let stepInvalid = false;
        switch (`${index}`) {
            case "0": // datos generales
                if (Object.keys(errors).length !== 0 || (Object.keys(touched).length !== 0)) {
                    if (
                        'customers_rfc' in errors ||
                        'customers_name' in errors ||
                        'address_pais' in errors ||
                        'customers_email' in errors ||
                        'customers_num_regid_trib' in errors ||
                        'cat_tax_regime_id' in errors
                    ) {
                        stepInvalid = true
                    }
                }
                break;
            case "1": // domicilio
                if (Object.keys(errors).length !== 0 || (Object.keys(touched).length !== 0)) {
                    if (
                        'address_calle' in errors ||
                        'address_no_exterior' in errors ||
                        'address_no_interior' in errors ||
                        'address_colonia' in errors ||
                        'address_referencia' in errors ||
                        'address_municipio' in errors ||
                        'address_localidad' in errors ||
                        'address_estado' in errors ||
                        'address_codigo_postal' in errors
                    ) {
                        stepInvalid = true
                    }
                }
                break;
            case "2": // contacto
                if (Object.keys(errors).length !== 0 || (Object.keys(touched).length !== 0)) {
                    if (
                        'customers_telefono' in errors ||
                        'customers_fax' in errors ||
                        'customers_email_2' in errors ||
                        'customers_email_3' in errors ||
                        'customers_pagina_web' in errors
                    ) {
                        stepInvalid = true
                    }
                }
                break;
        }

        return submitFailed && stepInvalid;
    }

    useEffect(() => {
        //console.log('mount')
        return () => {
            //console.log('unmount');
        }
    }, [])

    return (
        <Form
            onSubmit={onSubmit}
            initialValues={initialValues}
            validate={validateForm}
            render={(
                {
                    handleSubmit,
                    errors,
                    values,
                    touched,
                    submitFailed,
                    form
                }
            ) => {
                const errosStep1 = hasErrorStep(submitFailed, touched, errors, 0);
                const errosStep2 = hasErrorStep(submitFailed, touched, errors, 1);
                const errosStep3 = hasErrorStep(submitFailed, touched, errors, 2);

                const iconError = <Icon icon={alertCircleFill} color={PRIMARY.main} width={40} />;
                const subtitleError = <span style={{ color: PRIMARY.main }}>{t('common.form_error')}</span>;

                const steps: TStep[] = [
                    {
                        id: 'first-step',
                        key: 'first-step',
                        title: t("clients.general_title"),
                        component: <GeneralForm
                            values={values}
                            required={required}
                            selectDataCountry={selectDataCountry}
                            selectDataRegime={selectDataRegime}
                        />,
                        hasError: errosStep1,
                        iconError: (errosStep1) && iconError,
                        subtitle: (errosStep1) && subtitleError
                    },
                    {
                        id: 'second-step',
                        key: 'second-step',
                        title: t("clients.address_title"),
                        component: <AddressForm
                            values={values}
                            required={required}
                        />,
                        hasError: errosStep2,
                        iconError: (errosStep2) && iconError,
                        subtitle: (errosStep2) && subtitleError
                    },
                    {
                        id: 'third-step',
                        key: 'third-step',
                        title: t("clients.contact_title"),
                        component: <ContactForm
                            values={values}
                            required={required}
                        />,
                        hasError: errosStep3,
                        iconError: (errosStep3) && iconError,
                        subtitle: (errosStep3) && subtitleError
                    },
                ];

                const component = <AccordionWrapper steps={steps} defaultExpanded={0} showOnlyOneTab />;

                const modalProps: any = {
                    hasMenuItem: false,
                    label: t('clients.title'),
                    title: t('clients.title'),
                    initialValues,
                    validateForm,
                    required,
                    submitting,
                    component,
                    icon,
                    handleSubmit,
                    errors,
                    values,
                    touched,
                    submitFailed,
                    form,
                    callback,
                    setModalOpen,
                    loading
                }

                return (
                    <>
                        {
                            !isModal &&
                            <form onSubmit={handleSubmit} noValidate>
                                {component}

                                <LoadingButton
                                    sx={{ mt: 3, mr: 1 }}
                                    size="large"
                                    type="submit"
                                    variant="contained"
                                    loading={submitting}
                                >
                                    {t("common.save")}
                                </LoadingButton>
                            </form>
                        }

                        {
                            isModal &&
                            <MenuItemModalFormAccordion
                                {...modalProps}
                            />
                        }
                    </>
                )
            }}
        />
    );
}

export default AccordionForm;
